<template>
  <div class="volunteer">
    <BasePage mode="list">
      <div slot="toolBar">
        <div class="search-box">
          <el-input
            class="toolBar-search"
            v-model="request.searchKey"
            placeholder="关键字"
          />
          <el-button
            size="small"
            icon="el-icon-search"
            type="danger"
            @click="loadData(1)"
            >查询</el-button
          >
          <el-button
            size="small"
            icon="el-icon-download"
            type="danger"
            @click="exportVolunteer()"
            :loading="isExport"
            >导出</el-button
          >
        </div>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        border
        :max-height="tableMaxHeight()"
      >
        <el-table-column
          prop="Id"
          label="志愿者编号"
          width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="Name" label="姓名" />
        <el-table-column
          prop="Mobile"
          label="手机号码"
          width="130"
          align="center"
        />
        <el-table-column
          prop="Email"
          label="邮箱"
          show-overflow-tooltip
          width="200"
        />
        <!-- <el-table-column
          prop="Address"
          label="通信地址"
          show-overflow-tooltip
        /> -->
        <el-table-column
          prop="CreateTime"
          label="申请时间"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ (scope.row.CreateTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="Duration" label="总工时" width="140">
          <template slot-scope="scope">
            {{ scope.row.Duration | duration }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              v-access:read
              type="text"
              size="mini"
              @click="query(scope.row)"
              >详情</el-button
            >
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="add(scope.row)"
              >添加工时</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
    </BasePage>
    <volunteerBasicInfo
      :userId="userId"
      v-if="showVolunteer"
      @onCancel="onCancel"
    />
    <el-dialog
      title="志愿者详情"
      :visible.sync="dialogVisible"
      width="30%"
      class="detailDialog"
    >
      <div class="dialog-box">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.Title" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="工时">
            <el-input v-model="form.Duration" placeholder="请输入工时(分钟)" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="form.Remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import volunteerBasicInfo from "@/modules/zjrc/pages/volunteer/components/basicinfo/basicinfo.vue";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "volunteer",
  data() {
    return {
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
      },
      list: [],
      total: 0,
      loading: false,
      userId: "",
      showVolunteer: false,
      dialogVisible: false,
      form: {},
      isExport: false,
    };
  },
  components: {
    BasePage,
    OfPagination,
    volunteerBasicInfo,
  },
  mounted() {
    const vm = this;
    vm.loadData(1);
  },
  methods: {
    exportVolunteer() {
      const vm = this;
      const param = {
        keyWord: vm.request.searchKey,
      };
      vm.isExport = true;
      api
        .exportVolunteer(param)
        .then((res) => {
          if (res.data.Code === 0) {
            saveAs(res.data.Data, "志愿者信息.xls");
          } else {
            vm.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .finally(() => {
          vm.isExport = false;
        });
    },
    onSubmit() {
      const vm = this;
      api.saveVolunteerRecruitSignByAdmin(vm.form).then((res) => {
        if (res.data.Code === 0) {
          vm.$message({
            message: "已提交",
            type: "success",
          });
          vm.dialogVisible = false;
        }
      });
    },
    add(row) {
      const vm = this;
      vm.form = { userId: row.UserId };
      vm.dialogVisible = true;
    },
    onCancel() {
      const vm = this;
      vm.showVolunteer = false;
    },
    query(row) {
      const vm = this;
      vm.userId = row.UserId;
      vm.showVolunteer = true;
    },
    loadData(pageIndex) {
      const vm = this;
      vm.request.pageIndex = pageIndex;
      api.QueryApplyVolunteer(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.list = res.data.Data.rows;
          vm.total = res.data.Data.total;
        }
      });
    },
    handleCurrentChange(pageIndex) {
      const vm = this;
      if (vm.total > vm.request.pageSize) {
        vm.loadData(pageIndex);
      }
    },
    handleSizeChange(pageSize) {
      const vm = this;
      vm.request.pageSize = pageSize;
      vm.loadData(1);
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.volunteer {
  .search-box {
    text-align: right;
    .toolBar-search {
      width: 300px;
      margin-right: 10px;
    }
  }
}
</style>
